import { IOWidget, Action, Pair, nothing } from "widgets-for-react";
import { ExtraImages } from "../../utils/extra_images.mod";
import { BlockData, CMSState } from "../../../cms/blocks/types.gen";
import { Block } from "../../../wordpress/types_and_parser/standard_blocks.gen";
import { mapBlockProps, mapBlockStyle, mapBlock } from "./widgets/mapBlock";
import { MediaBlockProps, MediaBlockStyle, MediaBlock } from "./widgets/mediaBlock.mod";
import { IframeBlockProps, IframeBlockStyle, IframeBlock } from "./widgets/iframeBlock.mod";
import { RekenToolBlock, RekenToolBlockProps, RekenToolBlockStyle } from "./widgets/rekentoolBlock.mod";
import { CustomBlock } from "../../../wordpress/types_and_parser/custom_blocks.mod";
import { DownloadsBlock, DownloadsBlockProps, DownloadsBlockStyle } from "./widgets/downloadsBlock";
import { QuoteBlock, QuoteBlockProps, QuoteBlockStyle } from "./widgets/quoteBlock.mod";
import { HeroBlockProps, HeroBlockStyle, HeroBlock } from "./widgets/heroBlock.mod";
import { PublicSite_CustomPageData } from "../../application.mod";
import { CtaBlockStyle, CtaBlockProps, CtaBlock } from "./widgets/ctaBlock";
import { TextBlockStyle, TextBlockProps, TextBlock } from "./widgets/textBlock.mod";
import { FormBlockProps, FormBlockStyle, FormBlock } from "./widgets/formBlock.mod";
import { LatestBlockProps, LatestBlockStyle, LatestBlock } from "./widgets/latestBlock";
import { StoryBlockProps, StoryBlockStyle, StoryBlock } from "./widgets/storyBlock";
import { TableBlock, TableBlockProps, TableBlockStyle } from "./widgets/tableBlock.mod";
import { PublicSiteState } from "../../../public_site.main.mod";
import { CoreBlock, CoreBlockProps, CoreBlockStyle } from "./widgets/coreBlock";
import { LinkBlockProps, LinkBlockStyle } from "../../../cms/blocks/widgets/linkBlock.gen";
import { LinkBlock } from "./widgets/linkBlock.mod";
import { DownloadItemBlockProps, DownloadItemBlockStyle, DownloadItemBlock } from "./widgets/downloadItemBlock";
import { VideoCtaBlock, VideoCtaBlockProps, VideoCtaBlockStyle } from "./widgets/videoCta";
import { gridBlock, gridBlockProps, gridBlockStyle } from "./widgets/gridBlock";
import { gridWithImageBlockProps, gridWithImageBlockStyle, gridWWithImageBlock } from "./widgets/gridWithImageBlock";
import { VideoLibraryBlock, VideoLibraryBlockProps, VideoLibraryBlockStyle } from "./widgets/videoLibraryBlock";
import { PageNavigationBlockProps, PageNavigationBlockStyle, PageNavigationBlock } from "./widgets/pageNavigation";
import { LottiAnimationBlockProps, LottiAnimationBlockStyle, LottiAnimationBlock } from "./widgets/lottiAnimationBlock";
import { ImageTextBlockProps, ImageTextBlockStyle, ImageTextBlock } from "./widgets/imageTextBlock.mod";

//add here your custom blocks definitions
export type mapBlockData = { kind: "mapBlock"; value: Pair<mapBlockProps, mapBlockStyle> }
export type mediaBlockData = { kind: "mediaBlock"; value: Pair<MediaBlockProps<ExtraImages>, MediaBlockStyle> }
export type iframeBlockData = { kind: "iframeBlock"; value: Pair<IframeBlockProps, IframeBlockStyle> }
export type rekenToolBlockData = { kind: "rekenToolBlock"; value: Pair<RekenToolBlockProps, RekenToolBlockStyle> } // maximalehypotheek & hypotheekoversluiten
export type downloadsBlockData = { kind: 'downloadsBlock'; value: Pair<DownloadsBlockProps, DownloadsBlockStyle> }
export type downloadItemBlockData = { kind: 'downloadItemBlock'; value: Pair<DownloadItemBlockProps, DownloadItemBlockStyle> }
export type quoteBlockData = { kind: "quoteBlock"; value: Pair<QuoteBlockProps<ExtraImages>, QuoteBlockStyle> }
export type heroBlockData = { kind: 'heroBlock'; value: Pair<HeroBlockProps<ExtraImages>, HeroBlockStyle> }
export type ctaBlockData = { kind: 'ctaBlock'; value: Pair<CtaBlockProps, CtaBlockStyle> }
export type textBlockData = { kind: 'textBlock'; value: Pair<TextBlockProps<CustomBlockData, ExtraImages>, TextBlockStyle> }
export type linkBlockData = { kind: 'linkBlock'; value: Pair<LinkBlockProps, LinkBlockStyle> }
export type formBlockData = { kind: 'formBlock'; value: Pair<FormBlockProps, FormBlockStyle> }
export type latestBlockData = { kind: 'latestBlock'; value: Pair<LatestBlockProps, LatestBlockStyle> }
export type storyBlockData = { kind: 'storyBlock'; value: Pair<StoryBlockProps, StoryBlockStyle> }
export type tableBlockData = { kind: 'tableBlock'; value: Pair<TableBlockProps, TableBlockStyle> }
export type coreBlockData = { kind: 'coreBlock'; value: Pair<CoreBlockProps, CoreBlockStyle> }
export type videoCtaBlockData = { kind: 'videoCtaBlock'; value: Pair<VideoCtaBlockProps, VideoCtaBlockStyle> }
export type gridBlockData = { kind: 'gridBlock'; value: Pair<gridBlockProps, gridBlockStyle> }
export type gridWithImageBlockData = { kind: 'gridWithImageBlock'; value: Pair<gridWithImageBlockProps, gridWithImageBlockStyle> }
export type videoLibraryBlockData = { kind: 'videoLibraryBlock'; value: Pair<VideoLibraryBlockProps, VideoLibraryBlockStyle> }
export type PageNavigationBlockData = { kind: 'pageNavigationBlock'; value: Pair<PageNavigationBlockProps, PageNavigationBlockStyle> }
export type LottiAnimationBlockData = { kind: 'LottiAnimationBlock'; value: Pair<LottiAnimationBlockProps, LottiAnimationBlockStyle> }
export type TextWithImageBlockData = { kind: 'TextWithImageBlockData'; value: Pair<ImageTextBlockProps<ExtraImages>, ImageTextBlockStyle> }

export type CustomBlockData =
    | mapBlockData
    | mediaBlockData
    | downloadsBlockData
    | downloadItemBlockData
    | quoteBlockData
    | iframeBlockData
    | rekenToolBlockData // maximalehypotheek & hypotheekoversluiten
    | heroBlockData
    | textBlockData
    | ctaBlockData
    | formBlockData
    | latestBlockData
    | storyBlockData
    | tableBlockData
    | coreBlockData
    | linkBlockData
    | videoCtaBlockData
    | gridBlockData
    | gridWithImageBlockData
    | videoLibraryBlockData
    | PageNavigationBlockData
    | LottiAnimationBlockData
    | TextWithImageBlockData


export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
    return b.kind == "mapBlock" ||
        b.kind == "mediaBlock" ||
        b.kind == "downloadsBlock" ||
        b.kind == "downloadItemBlock" ||
        b.kind == "quoteBlock" ||
        b.kind == "iframeBlock" ||
        b.kind == "rekenToolBlock" || // maximalehypotheek & hypotheekoversluiten
        b.kind == "heroBlock" ||
        b.kind == "formBlock" ||
        b.kind == "ctaBlock" ||
        b.kind == "textBlock" ||
        b.kind == "latestBlock" ||
        b.kind == "storyBlock" ||
        b.kind == "tableBlock" ||
        b.kind == "coreBlock" ||
        b.kind == "linkBlock" ||
        b.kind == "videoCtaBlock" ||
        b.kind == 'gridBlock' ||
        b.kind == 'gridWithImageBlock' ||
        b.kind == 'videoLibraryBlock' ||
        b.kind == 'pageNavigationBlock' ||
        b.kind == 'LottiAnimationBlock' ||
        b.kind == 'TextWithImageBlockData'
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
    return b.kind == "vidda/map" ||
        b.kind == "vidda/media" ||
        b.kind == "vidda/download" ||
        b.kind == "vidda/download-item" ||
        b.kind == "vidda/quote" ||
        b.kind == "vidda/iframe" ||
        b.kind == "vidda/rekentool-maximalehypotheek" ||
        b.kind == "vidda/rekentool-hypotheekoversluiten" ||
        b.kind == "vidda/hero" ||
        b.kind == "vidda/form" ||
        b.kind == "vidda/cta" ||
        b.kind == "vidda/text" ||
        b.kind == "vidda/latest" ||
        b.kind == "vidda/storyblock" ||
        b.kind == "vidda/table" ||
        b.kind == "core/list" ||
        b.kind == "core/heading" ||
        b.kind == "core/paragraph" ||
        b.kind == "vidda/link-list" ||
        b.kind == 'vidda/video-cta' ||
        b.kind == 'vidda/grid' ||
        b.kind == 'vidda/grid-with-image' ||
        b.kind == 'vidda/video-library' ||
        b.kind == 'vidda/page-navigation' ||
        b.kind == 'vidda/animation-lotti' ||
        b.kind == 'vidda/image-text'
}

export function renderCustomBlock(block: CustomBlockData, public_state: PublicSiteState, key?: string): IOWidget<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
    return s0 => {
        if (block.kind == "mapBlock") {
            return mapBlock(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "mediaBlock") {
            return MediaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "downloadsBlock") {
            return DownloadsBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "downloadItemBlock") {
            return DownloadItemBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "quoteBlock") {
            return QuoteBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "iframeBlock") {
            return IframeBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "rekenToolBlock") { // maximalehypotheek & hypotheekoversluiten
            return RekenToolBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "ctaBlock") {
            return CtaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "textBlock") {
            return TextBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "heroBlock") {
            return HeroBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "formBlock") {
            return FormBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "latestBlock") {
            return LatestBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "storyBlock") {
            return StoryBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "tableBlock") {
            return TableBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "linkBlock") {
            return LinkBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "coreBlock") {
            return CoreBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "videoCtaBlock") {
            return VideoCtaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == 'gridBlock') {
            return gridBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == 'gridWithImageBlock') {
            return gridWWithImageBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == 'videoLibraryBlock') {
            return VideoLibraryBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "pageNavigationBlock") {
            return PageNavigationBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd, key })(s0)(public_state)
        }
        else if (block.kind == 'LottiAnimationBlock') {
            return LottiAnimationBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd, key })(s0)(public_state)
        }
        else if (block.kind == 'TextWithImageBlockData') {
            return ImageTextBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else {
            return nothing();
        }
    }
}




// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/types.mod.tsx